// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"FormDropzone_dropzone__3GNk_","dropzoneNotes":"FormDropzone_dropzoneNotes__2BSid","dropzoneActive":"FormDropzone_dropzoneActive__1EssB"};